/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useGetFilterSelections } from '@/catalog-apps/hooks/useGetFilterSelections'
import { isUISchema, StatementEditorResponse } from './types-v6'
// import { json } from '../../../mock-data/statement-editor/statement-editor-empty-response.json'
// import { json } from '../../../mock-data/statement-editor/statement-editor-v8-editing.json'
// import { json } from '../../../mock-data/statement-editor/statement-editor-joseph-v2.json'
// import { json } from '../../../mock-data/statement-editor/statement-editor-response-v8.json'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { useGetPageFilters } from '../../AppPage2/Filter/useGetPageFilters'
import { addPositionToContentBlocks } from './utils'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'
import { TComponentType } from '../../AppPage2/types'

const USE_MOCK_DATA = false

// const statementEditorResponse = json as unknown as StatementEditorResponse

// Enhance the statementEditorResponse with position information
const enhanceStatementEditorResponse = (response: StatementEditorResponse) => {
  if (!isUISchema(response.uiSchema)) {
    return response
  }
  const enhancedResponse = { ...response }
  const { indexData, contentData } = enhancedResponse.dataSchema

  // Apply the position transformation
  const contentDataWithPosition = addPositionToContentBlocks(contentData, indexData)

  // Replace the contentData with the enhanced version
  enhancedResponse.dataSchema.contentData = contentDataWithPosition

  return enhancedResponse as StatementEditorResponse
}

interface GetChartParams {
  appKey?: string
  contentId?: string
  projectId?: number
  filterSelections: Record<string, any>[]
  isPageBuilder?: boolean
}
const getStatementEditor = async ({
  appKey,
  contentId,
  projectId,
  filterSelections,
  isPageBuilder,
}: GetChartParams) => {
  if (!appKey || !contentId || !projectId) {
    throw new Error('Missing required parameters')
  }
  if (isPageBuilder || USE_MOCK_DATA) {
    return enhanceStatementEditorResponse(
      (await Promise.resolve({
        ...(await import('@/catalog-apps/mock-data/statement-editor/statement-editor-v8-editing.json')).json,
      })) as StatementEditorResponse
    )
  }
  // return Promise.resolve(enhanceStatementEditorResponse(statementEditorResponse))
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  if (!token) {
    throw new Error('No token found')
  }
  const url = `${ENDPOINTS.CC_DOTNET}/content`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      app_id: appKey,
      content_id: contentId,
      project_id: projectId,
      filters: filterSelections,
    }),
  })
  const data = await response.json()
  if (response.ok) {
    return enhanceStatementEditorResponse(data)
    // return data as StatementEditorResponse
  }
  throw new Error('Failed to fetch chart')
}

export function useGetStatementEditor(contentId: string, tileFilterSelections: Record<string, any>[]) {
  const isPageBuilder = useIsPageBuilder()
  const {
    data: { defaultSelections },
  } = useGetPageFilters()
  const { filterSelections } = useGetFilterSelections()
  const { appKey, projectId } = useAppContext()
  const filterSelectionsArray =
    filterSelections.length > 0
      ? [...filterSelections, ...tileFilterSelections]
      : [...defaultSelections, ...tileFilterSelections]
  const componentType: TComponentType = 'statement-editor'
  return useSuspenseQuery({
    queryKey: [contentId, componentType, appKey, projectId, filterSelectionsArray, isPageBuilder],
    queryFn: () =>
      getStatementEditor({
        appKey,
        contentId,
        projectId,
        filterSelections: filterSelectionsArray,
        isPageBuilder,
      }),
  })
}
